<rcl-modal
	id="cruise-history-rcl-modal"
	[show]="showHistoryModal"
	[mobileFullScreen]="false"
	[attr.aria-hidden]="!showHistoryModal"
	(onClose)="historyModalState === 'first' ? closeModal('skip') : closeModal('done')"
>
	<rcl-modal-content id="cruise-history-rcl-modal__content-modal1" *ngIf="historyModalState === 'first'">
		<p id="cruise-history-rcl-modal__content-modal1__modal1" class="rcl-h5 rcl-center-sm">
			{{ bundle && bundle['qq.cruise.history.modal1'] }}
		</p>
		<h1 id="cruise-history-rcl-modal__content-modal1__modal1-h1" class="rcl-modal-title rcl-h3">
			{{ bundle && bundle['header.cruise.history.modal1'] }}
		</h1>
		<div id="cruise-history-rcl-modal__content-modal1__container" class="rcl-container">
			<div class="rcl-row rcl-around-sm">
				<button
					id="cruise-history-rcl-modal__content-modal1__container__button-yes"
					(click)="historyModalContinue(true)"
					class="rcl-button-primary yes-no-buttons"
				>
					{{ bundle && bundle['expense.account.button.add.more.guests.yes'] }}
				</button>
				<button
					id="cruise-history-rcl-modal__content-modal1__container__button-no"
					(click)="historyModalContinue(false)"
					class="rcl-button-primary yes-no-buttons"
				>
					{{ bundle && bundle['button.no'] }}
				</button>
			</div>
		</div>
	</rcl-modal-content>
	<rcl-modal-content id="cruise-history-rcl-modal__content-modal2" *ngIf="historyModalState === 'thanks'" [attr.tabindex]="0">
		<div class="rcl-center-sm">
			<img
				id="cruise-history-rcl-modal__content-modal2__img-icon-checkbox"
				src="assets/icons/icon-checkbox-{{ brandName }}.svg"
				alt=""
			/>
		</div>
		<h1 id="cruise-history-rcl-modal__content-modal2__modal2-h1" class="rcl-modal-title rcl-h3">
			{{ bundle && bundle['header.cruise.history.modal2'] }}
		</h1>
		<p id="cruise-history-rcl-modal__content-modal2__modal2" class="rcl-h4 rcl-center-sm">
			{{ bundle && bundle['subheader.cruise.history.modal2'] }}
		</p>
	</rcl-modal-content>
	<rcl-modal-actions id="cruise-history-rcl-modal__actions">
		<button
			id="cruise-history-rcl-modal__actions__close-skip"
			*ngIf="historyModalState === 'first'"
			(click)="closeModal('skip')"
			class="rcl-button-tertiary"
		>
			{{ bundle && bundle['skip.cruise.history.modal1'] }}
		</button>
		<button
			id="cruise-history-rcl-modal__actions__close-done"
			*ngIf="historyModalState === 'thanks'"
			(click)="closeModal('done')"
			class="rcl-button-secondary"
		>
			{{ bundle && bundle['done.cruise.history.modal2'] }}
		</button>
	</rcl-modal-actions>
</rcl-modal>
